import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadge = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      label: 'Criptografia SSL',
      description: 'Conexão segura'
    },
    {
      icon: 'Lock',
      label: 'Autenticação 2FA',
      description: 'Proteção adicional'
    },
    {
      icon: 'Eye',
      label: 'Monitoramento',
      description: 'Atividade registrada'
    }
  ];

  return (
    <div className="w-full space-y-4">
      <div className="flex items-center gap-2 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center glow-primary">
          <Icon name="ShieldCheck" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-base md:text-lg font-heading font-bold text-primary">
            Segurança Avançada
          </h3>
          <p className="text-xs text-muted-foreground">
            Proteção em múltiplas camadas
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="flex items-start gap-3 p-3 rounded-lg bg-card/50 border border-primary/20 transition-smooth hover:border-primary/40 hover:glow-primary-hover"
          >
            <div className="w-8 h-8 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name={feature?.icon} size={16} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground">
                {feature?.label}
              </p>
              <p className="text-xs text-muted-foreground mt-0.5">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 rounded-lg bg-muted/30 border border-primary/10">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={16} color="var(--color-secondary)" className="flex-shrink-0 mt-0.5" />
          <p className="text-xs text-muted-foreground leading-relaxed">
            Todas as tentativas de login são monitoradas e registradas para garantir a segurança do sistema.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SecurityBadge;